import PropTypes from 'prop-types'
import { memo, useMemo, useRef } from 'react'
import Button from 'components/core/Button/Button'
import useActiveStateAnimationChildren from 'lib/react/hooks/useActiveStateAnimationChildren'

/**
 * The `ContentButton` component is used to render
 * standard HTML based content
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ContentButton (props) {
  const { align, config, isActive, label, styles } = props
  const ref = useRef()
  const styleAttribute = useMemo(
    () => ({
      textAlign: align,
      ...styles
    }),
    [align, styles]
  )

  // Animation
  useActiveStateAnimationChildren(ref, isActive)

  return (
    <Button Tag="a" ref={ref} style={styleAttribute} size="xl" {...config}>
      {label}
    </Button>
  )
}

/** @type {object} */
ContentButton.propTypes = {
  internal: PropTypes.bool,
  align: PropTypes.string,
  isActive: PropTypes.bool,
  styles: PropTypes.shape(),
  config: PropTypes.shape(),
  label: PropTypes.string
}

/** @type {object} */
ContentButton.defaultProps = {
  internal: false,
  align: 'inherit',
  label: '',
  config: {},
  isActive: false,
  styles: {}
}

export default memo(ContentButton)
